module.exports = __webpack_public_path__ + "static/headphones-product-sale-off-section-code-c52b483c9715df35e408a7a2d6214fd6.png";